import {SortingOrderEnum} from '../../enums/SortingOrder.enum';

export const getIsAscSortOrder = (sort: SortingOrderEnum) => sort === SortingOrderEnum.ASC;
